import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Confirm, Popup } from "semantic-ui-react";
import { wikiDelete } from "../../store/actions/wikiActions";
import EditWikiModal from "./EditWikiModal";
import WikiAdModal from "./WikiAdvocateModal";
import WikiDocumentModal from "./WikiDocumentModal";
export const placeHolderImage =
  "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png";

const EventCard = (props) => {
  const [open, setOpen] = React.useState(false);
  const [adOpen, setAdOpen] = React.useState(false);
  const [editWiki, setEditWiki] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [deleteId, setdeleteId] = useState(null);
  const dispatch = useDispatch();

  const handleEdit = (document) => {
    let advocate = null;
    if (document?.wikiAdvocate && props.wiki.advocates?.length > 0) {
      props.wiki.advocates.forEach((ele) => {
        if (ele.id === document?.wikiAdvocate) {
          advocate = ele;
        }
      });
    }
    setEditWiki(document);
    setAdvocate(advocate);
  };
  return (
    <>
      <div className="list-data eventDetails-data">
        {props.superAdmin && (
          <div className="close-btn-list">
            <Button
              circular
              icon="edit"
              color="blue"
              onClick={() => handleEdit(props.wiki)}
            />
            <Button
              icon="trash"
              basic
              color="red"
              circular
              className="last"
              onClick={() => {
                setdeleteId(props.wiki.id);
              }}
            />
          </div>
        )}

        {props.wiki.fileName && props.wiki.file && (
          <a
            href={props.file ? props.file : props.wiki.file}
            className="eventTitle custom-title"
            target="blank"
            rel="noopener noreferrer"
          >
            {props.fileName ? props.fileName : props.wiki.fileName}
          </a>
        )}

        {!props.profile && props.advocate && (
          <div
            className="event-btn-data"
            style={{ float: "right", width: "auto" }}
          >
            <div className="one" style={{ width: "auto" }}>
              <a
                href={props.wiki.file}
                className="eventTitle custom-title"
                target="blank"
                rel="noopener noreferrer"
                style={{ float: "left" }}
              >
                <Popup
                  content={props.wiki.fileName}
                  trigger={
                    <Button circular icon="linkify" color="black" basic />
                  }
                />
              </a>
              <Button
                circular
                icon="edit"
                color="blue"
                onClick={() => handleEdit(props.wiki)}
              />
            </div>
          </div>
        )}
      </div>

      {props.wiki.advocates && props.wiki.advocates.length > 0 && (
        <WikiAdModal
          open={adOpen}
          setOpen={(v) => setAdOpen(v)}
          wiki={props.wiki}
        />
      )}
      {props.wiki.wikis && props.wiki.wikis.length > 0 && (
        <WikiDocumentModal
          open={open}
          setOpen={(v) => setOpen(v)}
          wiki={props.wiki}
        />
      )}
      <Confirm
        open={deleteId}
        content="You Sure Want To Delete ? You Can't Undo It"
        onCancel={() => {
          setdeleteId(null);
        }}
        onConfirm={() => {
          dispatch(wikiDelete(deleteId));
          setdeleteId(null);
        }}
      />
      <EditWikiModal
        open={editWiki}
        close={() => setEditWiki(null)}
        advocate={advocate}
        fromAdvocate
      />
    </>
  );
};

export default EventCard;
